import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CustomRouteService } from 'src/app/pages/custom-route/services';
import { EditedCustomRouteDataSyncBody } from 'src/app/pages/custom-route/shared/planner/components/route-timeline/components/daily-route-list/interfaces/edit-route.interface';
import { EditRouteService } from 'src/app/pages/custom-route/shared/planner/components/route-timeline/components/daily-route-list/services';

type ModifyItemArgs = {
  action: string;
  completion_id: string;
  element_id?: string | number;
  found_name?: string;
  type: 'point' | 'event';
  sync_payload: EditedCustomRouteDataSyncBody;
};

@Injectable({
  providedIn: 'root'
})
export class ModifyCustomRoute {
  private _customRouteService = inject(CustomRouteService);
  private _editRouteService = inject(EditRouteService);
  
  private _originalCustomRouteData = this._customRouteService.originalCustomRouteData;
  private _editedCustomRouteData = this._editRouteService.editedCustomRouteData;
  private _errorEditedCustomRouteData = this._editRouteService.errorEditedCustomRouteData;

  public modifyItem(args: ModifyItemArgs): Observable<{ is_successful: boolean; sync_payload?: EditedCustomRouteDataSyncBody }> {   
    const route = this._editedCustomRouteData() ?? this._originalCustomRouteData();

    if (!route?.dailyRoutes) {
      return of({ is_successful: false, reason: this._errorEditedCustomRouteData() });
    }

    return of({ is_successful: true, sync_payload: args.sync_payload });
  }
}
